
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $9dCmO = parcelRequire("9dCmO");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("8Rfa8")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, "");
        if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, "");
    } catch (e) {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match === null || match === void 0 ? void 0 : match[1]) {
            let pathname = match[1].replace(/\/+$/, "");
            if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, "");
        }
        return "";
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    "software/jira/product-discovery": {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira": {
        contactFlowId: "1825e6f7-75fc-47e2-b634-98923fa4a3b1",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom": {
        contactFlowId: "dc335c33-9da5-4291-842b-80956f53d2b7",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-confluence": {
        contactFlowId: "7cf56869-3db7-431e-8311-b524e6065934",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-jira": {
        contactFlowId: "199f4750-6436-4b88-a2db-c2b87c1bdaed",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/resources": {
        contactFlowId: "eadd2afc-29bb-4e9c-a0d6-370fd70186eb",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/ai-meeting": {
        contactFlowId: "364f6abb-5628-41c1-bf90-b3ca2486378d",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/editing": {
        contactFlowId: "a4addd51-eb96-46fc-b5a9-3f99c3d923de",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/company/contact/japan": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    var _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath;
    return (_CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath]) !== null && _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath !== void 0 ? _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath : {
        contactFlowId: ""
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ""
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === "object" && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return "{}";
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    return normalizedPath === "ja" || normalizedPath.startsWith("ja/");
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join("_");
    } catch (error) {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
            return pathParts.join("_");
        }
        return "";
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === "attachments") return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse === null || chatConnectionConfigResponse === void 0 ? void 0 : chatConnectionConfigResponse.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    var _contact_value;
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    return contact === null || contact === void 0 ? void 0 : (_contact_value = contact.value) === null || _contact_value === void 0 ? void 0 : _contact_value.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    const value = contact === null || contact === void 0 ? void 0 : contact.value;
    return {
        contactId: value === null || value === void 0 ? void 0 : value.contactId,
        participantId: value === null || value === void 0 ? void 0 : value.participantId,
        region: value === null || value === void 0 ? void 0 : value.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ""
        ],
        authenticated: isUserLoggedIn ? null : [
            "No"
        ],
        email: [
            isUserLoggedIn ? userEmail : ""
        ],
        customer_status: [
            "Customer"
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            "GMT+6"
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            "en"
        ],
        is_partner_dc_exception: [
            "Customer not in SFDC"
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split("_").join(" ")
        ],
        support_channel: [
            "chat"
        ],
        inquiry_category: [
            "access_issues"
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                "Chat Transcript for <email removed for privacy>"
            ],
            details: "",
            contactEmail: isUserLoggedIn ? userEmail !== null && userEmail !== void 0 ? userEmail : "" : "",
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    var _response_channelPlatform_getCustomerConversations_conversations, _response_channelPlatform_getCustomerConversations;
    var _response_channelPlatform_getCustomerConversations_conversations_length;
    const count = (_response_channelPlatform_getCustomerConversations_conversations_length = response === null || response === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations = response.channelPlatform_getCustomerConversations) === null || _response_channelPlatform_getCustomerConversations === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations_conversations = _response_channelPlatform_getCustomerConversations.conversations) === null || _response_channelPlatform_getCustomerConversations_conversations === void 0 ? void 0 : _response_channelPlatform_getCustomerConversations_conversations.length) !== null && _response_channelPlatform_getCustomerConversations_conversations_length !== void 0 ? _response_channelPlatform_getCustomerConversations_conversations_length : 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? "Loading chat" : "Open chat widget",
        style: {
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            cursor: isLoading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            backgroundColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            color: "white",
            boxShadow: (0, $lP7A9.default)("elevation.shadow.raised")
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};
function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: (0, $dPABA._)((0, $6ogO3._)({}, headers), {
                        "Content-Type": "application/json",
                        "X-Client-Hash": channelsIdentityHash
                    })
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "";
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            var _response_data;
            setCustomerConversationsResponse((_response_data = response === null || response === void 0 ? void 0 : response.data) !== null && _response_data !== void 0 ? _response_data : null);
        }).catch((err)=>{
            console.warn("Error fetching customer conversations:", err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) {
            console.warn("Client with token not available yet");
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail !== null && userEmail !== void 0 ? userEmail : "", isUserLoggedIn);
        var _JSON_parse;
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: "CHAT",
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: $c6548387155117f6$export$a40d7197cc58cf92($c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn)),
                attributes: (_JSON_parse = JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)))) !== null && _JSON_parse !== void 0 ? _JSON_parse : {},
                anonymousId: (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || ""
            }
        }).then((response)=>{
            setChatConnectionConfig(response === null || response === void 0 ? void 0 : response.data);
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching chat connection config:", err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: "sales"
            }
        }).then((response)=>{
            var _response_data;
            const token = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching channel platform token:", err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: "80%",
        height: 500
    };
    const omniChannelEnv = "production";
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || "",
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || "",
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });
// @ts-expect-error - @apollo/client is ESM but this file is treated as CommonJS by TypeScript

var $4Wqet = parcelRequire("4Wqet");
let $59b9792633dffc77$var$_ = (t)=>t, $59b9792633dffc77$var$t, $59b9792633dffc77$var$t1, $59b9792633dffc77$var$t2, $59b9792633dffc77$var$t3, $59b9792633dffc77$var$t4;
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)($59b9792633dffc77$var$t || ($59b9792633dffc77$var$t = $59b9792633dffc77$var$_`
    query channelPlatformTokenGeneration {
        supportInquiry_channelsIdentityHash
    }
`));
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)($59b9792633dffc77$var$t1 || ($59b9792633dffc77$var$t1 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
        $anonymousId: String
        $attributes: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: {
                payload: $payload
                metadata: $metadata
                attributes: $attributes
            }
            anonymousId: $anonymousId
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)($59b9792633dffc77$var$t2 || ($59b9792633dffc77$var$t2 = $59b9792633dffc77$var$_`
    query CustomerConversations($anonymousId: String) {
        channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
            conversations
        }
    }
`));
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)($59b9792633dffc77$var$t3 || ($59b9792633dffc77$var$t3 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: { payload: $payload, metadata: $metadata }
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)($59b9792633dffc77$var$t4 || ($59b9792633dffc77$var$t4 = $59b9792633dffc77$var$_`
    query channelPlatformTokenGenerationByClientName($clientName: String) {
        supportInquiry_channelsIdentityHashByClientName(
            request: { clientName: $clientName }
        )
    }
`));

});

parcelRegister("8Rfa8", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("eDmkW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("2TJ5h")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("geLsY")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hCwjc")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7dU12")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("irTWb")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("49mlB")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9WEDO")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gFcxC")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7Q4ht")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("76kmj"))
]).then(()=>parcelRequire('8Cs4z'));

});
parcelRegister("1athW", function(module, exports) {
"use strict";

var $1tHQt = parcelRequire("1tHQt");
module.exports = $1tHQt(function importModule(bundle) {
    return new Promise((resolve, reject)=>{
        // Add a global function to handle when the script loads.
        let globalName = `i${('' + Math.random()).slice(2)}`;
        $parcel$global[globalName] = (m)=>{
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        let cleanup = ()=>{
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        let script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = `import * as m from '${bundle}'; ${globalName}(m);`;
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("1tHQt", function(module, exports) {
"use strict";
let $113a82a87c54a561$var$cachedBundles = {};
let $113a82a87c54a561$var$cachedPreloads = {};
let $113a82a87c54a561$var$cachedPrefetches = {};
function $113a82a87c54a561$var$getCache(type) {
    switch(type){
        case 'preload':
            return $113a82a87c54a561$var$cachedPreloads;
        case 'prefetch':
            return $113a82a87c54a561$var$cachedPrefetches;
        default:
            return $113a82a87c54a561$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $113a82a87c54a561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6RJ0J", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hCwjc")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hx68B"))
]).then(()=>parcelRequire('cJIcN'));

});


var $35a712b837ca68f5$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('7riGl'), JSON.parse("[\"7riGl\",\"jira-product-discovery-page.8ecb75cb.js\",\"76kmj\",\"chat-widget-omni-channel-ui.62c4e63f.js\",\"6Hc2y\",\"modal.b41330ad.js\",\"brIi4\",\"datasourceTableView.1fcaf1be.js\",\"1Etsc\",\"modal.c862660f.js\",\"9a6Xx\",\"datasourceRenderFailedAnalyticsWrapper.1389393e.js\",\"2j0Db\",\"datasourceTableView.ef3c8723.js\",\"iCZTw\",\"dark.16cc06e7.svg\",\"eVZsY\",\"light.e350f7db.svg\",\"hdFVX\",\"custom-theme.92223c35.js\",\"7gQUy\",\"atlassian-light.f6b93219.js\",\"8PkqS\",\"atlassian-light-future.1d469fa3.js\",\"d1UJM\",\"atlassian-light-increased-contrast.52fe25fe.js\",\"5zUWn\",\"atlassian-dark.07f9db0b.js\",\"bi7iI\",\"atlassian-dark-future.69b39493.js\",\"8cEoG\",\"atlassian-dark-increased-contrast.f8e22f4b.js\",\"gJjFX\",\"atlassian-legacy-light.506fcccb.js\",\"ec8ot\",\"atlassian-legacy-dark.dccd648f.js\",\"165OO\",\"atlassian-spacing.4bfb30fe.js\",\"enFem\",\"atlassian-typography.e68ca169.js\",\"ekp1O\",\"atlassian-typography-adg3.811cbcf9.js\",\"cFJQy\",\"atlassian-shape.8b761943.js\",\"6oWPm\",\"atlassian-typography-modernized.bcdfa50b.js\",\"frMLF\",\"atlassian-typography-refreshed.a878c384.js\",\"j7ZNh\",\"atlassian-light-brand-refresh.983828b2.js\",\"c7cUo\",\"atlassian-dark-brand-refresh.e7042547.js\",\"8f4hZ\",\"dark.981334ac.svg\",\"kydQZ\",\"light.d61b1f64.svg\",\"32OrT\",\"custom-theme.3ce1e0b4.js\",\"lExK6\",\"atlassian-light.9f23d3b0.js\",\"63th3\",\"atlassian-light-future.e48c6267.js\",\"guCS1\",\"atlassian-light-increased-contrast.5dabd39e.js\",\"2tX9S\",\"atlassian-dark.80ec4b21.js\",\"zUvum\",\"atlassian-dark-future.8ec7b9c3.js\",\"2PhFQ\",\"atlassian-dark-increased-contrast.cceab0fe.js\",\"jDzBC\",\"atlassian-legacy-light.24da878a.js\",\"grs0i\",\"atlassian-legacy-dark.87e48c31.js\",\"91NZ1\",\"atlassian-spacing.bed5ec72.js\",\"033DE\",\"atlassian-typography.75e054e0.js\",\"7lg1U\",\"atlassian-shape.bd11fa99.js\",\"lzCLl\",\"dark.90199792.svg\",\"8quzl\",\"light.5ffcf568.svg\",\"liGvy\",\"component-lazy.b186be81.js\",\"aXHfO\",\"file-icon.6382334c.js\",\"8Gud5\",\"chart-bar-icon.90aefaa2.js\",\"9rbe5\",\"list-bullet-icon.408fcb9b.js\",\"8DwmE\",\"component-lazy.860d5969.js\",\"hc6ft\",\"file--document-filled.94401a3d.js\",\"gAaTd\",\"people-group.1b524ad5.js\",\"9yG1J\",\"16.0e69c809.js\",\"8hdJi\",\"16.fe2ebf72.js\",\"8EkaQ\",\"16.07dece65.js\",\"ea9vx\",\"16.27817dd7.js\",\"2DITZ\",\"16.532e5064.js\",\"9ysOW\",\"16.fe16d5a6.js\",\"d3VeM\",\"16.efe8427d.js\",\"f185M\",\"16.f3be0c4d.js\",\"bP6QH\",\"16.be15740a.js\",\"iIiz1\",\"16.81b264d1.js\",\"jlnZV\",\"16.7f985c3a.js\",\"49rYz\",\"16.c9d7a096.js\",\"f5THM\",\"16.9332c31c.js\",\"fS5aw\",\"component-lazy.9da0e571.js\",\"cNqyk\",\"custom-theme.1a46b0db.js\",\"67G18\",\"atlassian-light.763b6463.js\",\"9aHW1\",\"atlassian-light-future.02a541a2.js\",\"58YkL\",\"atlassian-light-increased-contrast.5fbc69bb.js\",\"lYtLB\",\"atlassian-dark.fc968d67.js\",\"hN1k8\",\"atlassian-dark-future.89623828.js\",\"2vgig\",\"atlassian-dark-increased-contrast.78169ba4.js\",\"2Z9sD\",\"atlassian-legacy-light.5c90cf28.js\",\"6Z3Ag\",\"atlassian-legacy-dark.38d25600.js\",\"7sysd\",\"atlassian-spacing.d3d2ba26.js\",\"4lKL9\",\"atlassian-typography.a2b43917.js\",\"2LUz0\",\"atlassian-typography-adg3.a8e6266f.js\",\"aDLAv\",\"atlassian-shape.0aef533f.js\",\"l7WJj\",\"atlassian-shape-rounder.0d20359b.js\",\"9qg9C\",\"atlassian-shape-roundest.6d997db4.js\",\"8Xrqp\",\"atlassian-typography-modernized.25b42f27.js\",\"aJe4E\",\"atlassian-typography-refreshed.d4b7b748.js\",\"ZOcdO\",\"atlassian-light-brand-refresh.f7c589d9.js\",\"d7t6F\",\"atlassian-dark-brand-refresh.0fa10616.js\",\"bTaOO\",\"audio-icon.1db92a00.js\",\"jkouq\",\"angle-brackets-icon.cea339eb.js\",\"eyGRK\",\"folder-icon.9f067edb.js\",\"90sX7\",\"image-icon.61522776.js\",\"kCVhd\",\"video-icon.2ccc971b.js\",\"2E2HA\",\"lock-locked--lock-filled.d871b7e9.js\",\"lRI2Y\",\"16.29f3ee0e.js\",\"fWWE5\",\"24.33f8b5e6.js\",\"8o7Ts\",\"16.3d6ce7d9.js\",\"cFvqv\",\"24.26c7e16a.js\",\"eOvUw\",\"16.11bc83e2.js\",\"nm140\",\"24.1d56b600.js\",\"6CuKg\",\"16.5da13f88.js\",\"k9hlb\",\"24.7181b407.js\",\"8G5eK\",\"16.69bdd7bc.js\",\"9ri2N\",\"24.ab3b8256.js\",\"93J0M\",\"16.5f3459bf.js\",\"lrPIC\",\"24.184b47e3.js\",\"58qCs\",\"16.24201def.js\",\"kZbQK\",\"24.3e2bdfe2.js\",\"lgPBh\",\"16.52a7c786.js\",\"iZF5R\",\"24.3f8af853.js\",\"8I81U\",\"16.a30001ec.js\",\"hT09x\",\"24.3c4333ca.js\",\"cwE10\",\"16.1135c905.js\",\"aCrGD\",\"24.ba34de6d.js\",\"8HMJx\",\"16.0e0a327d.js\",\"dvNrH\",\"24.9bbf528e.js\",\"9lj4x\",\"16.b2821e85.js\",\"jtSYT\",\"24.ce139d5a.js\",\"cxK3I\",\"24.b7991a63.js\",\"dPh4e\",\"24.e6b0f67b.js\",\"9YeU5\",\"24.e539b776.js\",\"6plOw\",\"24.045b8179.js\",\"6NidY\",\"24.61a7c3ba.js\",\"e0eIk\",\"24.5b9825b2.js\",\"95LIj\",\"24.42500713.js\",\"adbKr\",\"24.499a0ff0.js\",\"d6tGh\",\"24.4e1e205a.js\",\"iefvr\",\"24.cc8edb11.js\",\"kPBg6\",\"24.a0879d1f.js\",\"kA9tL\",\"24.7a3bc0e3.js\",\"4SXK0\",\"24.29efdd70.js\",\"Sydd2\",\"confluence-icon.8e842841.js\",\"cKgik\",\"jira-icon.a1193128.js\",\"lib95\",\"attachment.fa2f6369.js\",\"D5ka0\",\"task.f2dd8e56.js\",\"dXvbQ\",\"component.19fe7107.js\",\"1A6ym\",\"comment.9e3c3b84.js\",\"8CMvx\",\"eye-open--watch.8e086ef2.js\",\"9dm3d\",\"thumbs-up--like.be95e901.js\",\"4zav0\",\"arrow-up.607befc4.js\",\"l9PCY\",\"priority-blocker.96db6a03.js\",\"lRtmg\",\"priority-critical.2dc61834.js\",\"4lNLt\",\"priority-high.1fcdd926.js\",\"2oyYc\",\"priority-highest.09d9d9cf.js\",\"i4dsq\",\"priority-low.51bf5bbb.js\",\"lD1Rq\",\"priority-lowest.e7ea925f.js\",\"bgSXd\",\"priority-major.816583c5.js\",\"8z8vC\",\"priority-medium.3dd96ff2.js\",\"aEXtk\",\"priority-minor.d47aa469.js\",\"ck942\",\"priority-trivial.458ebaad.js\",\"e425q\",\"question-circle--question.0d021646.js\",\"5rsU4\",\"angle-brackets--code.2928729d.js\",\"1pVQO\",\"people-group--people.e221f2ac.js\",\"1ucEX\",\"subtasks--subtask.bd5b6caf.js\",\"UxexI\",\"goal-icon.ffb1b8c5.js\",\"6nPL4\",\"projects-icon.39c3c105.js\",\"y6CTt\",\"manual-triggers-modal.b5b2de67.js\",\"jUgWl\",\"RelatedLinksModal.66acf7a7.js\",\"iRXom\",\"EmbedModal.6aa3848d.js\",\"c6370\",\"modal.39e8b627.js\",\"5NarU\",\"standard.6c3cc6ed.svg\",\"bHEL0\",\"datasourceTableView.51c80da3.js\",\"gVnQ5\",\"modal.b4003f5c.js\",\"91vZe\",\"modal.69a53aab.js\",\"6JXuq\",\"modal.5db4c213.js\",\"6glGi\",\"dark.725705dc.svg\",\"f3gSE\",\"light.bf58aa10.svg\",\"dDNE6\",\"modal.227a0979.js\",\"kYefW\",\"ParseTreePatternMatcher.84c041cf.js\",\"axKjy\",\"atlassian-light.dcd3e8ad.js\",\"fKwGe\",\"atlassian-light-future.9644df0d.js\",\"eDQ9x\",\"atlassian-light-increased-contrast.3e896477.js\",\"7q0ad\",\"atlassian-dark.296e90e2.js\",\"4EQ5p\",\"atlassian-dark-future.5b92ac5f.js\",\"1QNh5\",\"atlassian-dark-increased-contrast.f2f404dd.js\",\"9hgng\",\"atlassian-legacy-light.8314f467.js\",\"6UfG0\",\"atlassian-legacy-dark.6febf0b0.js\",\"32081\",\"atlassian-spacing.ab6a20ea.js\",\"a32QV\",\"atlassian-typography.16e83754.js\",\"8AoS1\",\"atlassian-shape.353c7df9.js\",\"9zCJ4\",\"custom-theme.0c788215.js\",\"8b0Br\",\"modal.68ed3c6e.js\",\"geLsY\",\"modal.c47efd09.js\",\"k0cqj\",\"esm.563735fb.js\",\"3kYzk\",\"atlassian-light.112fe596.js\",\"4SBrD\",\"atlassian-light-future.acf3396f.js\",\"9JjvF\",\"atlassian-light-increased-contrast.275b4d1a.js\",\"aVUKw\",\"atlassian-dark.9b06d495.js\",\"8wzVE\",\"atlassian-dark-future.c51e4ab3.js\",\"40kuy\",\"atlassian-dark-increased-contrast.fcb85b5a.js\",\"aZlu4\",\"atlassian-legacy-light.63039387.js\",\"8h6aK\",\"atlassian-legacy-dark.51ac965e.js\",\"bNFL7\",\"atlassian-spacing.1888e647.js\",\"jSqFG\",\"atlassian-typography.094b97ba.js\",\"9RdKm\",\"atlassian-shape.48a46e25.js\",\"cwdbI\",\"custom-theme.b86f8bfd.js\",\"4hdf6\",\"action.0fdda5d9.js\",\"9Nq5w\",\"code.9e2725a1.js\",\"ePGFA\",\"date.a933f2f6.js\",\"991q1\",\"decision.0f75f1eb.js\",\"kLC4B\",\"divider.30e62c11.js\",\"hvmJX\",\"emoji.402b9f8e.js\",\"cEmjT\",\"images.1afe0281.js\",\"fOVzu\",\"layout.8328a55c.js\",\"a0uE3\",\"link.d5d9f03b.js\",\"csXda\",\"list-number.1a7a03ac.js\",\"3IfvT\",\"list.07939b2c.js\",\"fRMbE\",\"mention.07d188f4.js\",\"1enB6\",\"panel-error.1f127ced.js\",\"7RpMt\",\"panel-note.f8a10f49.js\",\"3pgks\",\"panel-success.7329a0a5.js\",\"6l9qM\",\"panel-warning.1e3f1e9d.js\",\"4Hqzu\",\"panel.fec755a2.js\",\"ktPG4\",\"quote.2dd1dca9.js\",\"k7byj\",\"status.c2069770.js\",\"YF1xP\",\"one-column-layout.28584fe2.js\",\"2oceX\",\"two-column-layout.d8158b92.js\",\"6DvU4\",\"three-column-layout.49d8e4ec.js\",\"d024f\",\"four-column-layout.81c99038.js\",\"eWrXe\",\"five-column-layout.5bb76cf9.js\",\"89orV\",\"feedback.8a17f73e.js\",\"dg3wD\",\"expand.535a1a74.js\",\"gWJBp\",\"datasource-jira-issue.78057a21.js\",\"4bbFn\",\"datasource-assets-objects.c9f14458.js\",\"dmUiG\",\"datasource-confluence-search.7edbb52f.js\",\"401Wt\",\"loom.2243393e.js\",\"cXmQo\",\"syncBlock.562b13c0.js\",\"jQbh8\",\"atlassian-light.150058c1.js\",\"1zC8Y\",\"atlassian-light-future.ccd47ee2.js\",\"1FHfC\",\"atlassian-light-increased-contrast.3bfd368d.js\",\"8BrUz\",\"atlassian-dark.849bf543.js\",\"d6NiB\",\"atlassian-dark-future.2684d56b.js\",\"lnRPn\",\"atlassian-dark-increased-contrast.080ce6d9.js\",\"cBs7P\",\"atlassian-legacy-light.b01e04a7.js\",\"aYkZC\",\"atlassian-legacy-dark.d70fa1a6.js\",\"bs7MW\",\"atlassian-spacing.bba2ddfb.js\",\"dmula\",\"atlassian-typography.16ce030a.js\",\"cqbwt\",\"atlassian-shape.a2f2e42c.js\",\"J9B3K\",\"custom-theme.dbb88596.js\",\"4zp3T\",\"cs.fde3500f.js\",\"lDs9X\",\"da.6596de11.js\",\"lJNEL\",\"de.a4c670f6.js\",\"7UxPo\",\"en_GB.8ac61aaa.js\",\"cVGIp\",\"en_ZZ.5791087a.js\",\"kH9DA\",\"es.ddc510fb.js\",\"cbkwA\",\"fi.490434c1.js\",\"1xrqJ\",\"fr.c955bb32.js\",\"8PwiF\",\"hu.c085ec8b.js\",\"9REdC\",\"it.242862cf.js\",\"bSFfJ\",\"ja.395550ed.js\",\"aoOBZ\",\"ko.d772b933.js\",\"fWwSy\",\"nb.72395892.js\",\"4P6NK\",\"nl.a9e47e5a.js\",\"8tp99\",\"pl.fdd656ca.js\",\"5isBg\",\"pt_BR.4ae9338f.js\",\"77Xeq\",\"ru.0db582c3.js\",\"fjXkb\",\"sv.2e631508.js\",\"5ppN6\",\"th.2ac53291.js\",\"2ZZAw\",\"tr.e6d66b86.js\",\"8obpi\",\"uk.cf10e55f.js\",\"ceexF\",\"vi.d6d04bcd.js\",\"acFsG\",\"zh_TW.a4baf3d0.js\",\"leOLb\",\"zh.eb2292c4.js\",\"dfmLT\",\"link-picker.a9fea63e.js\",\"b2fk5\",\"atlassian-light.98e9c996.js\",\"aHnB1\",\"atlassian-light-future.ddc6a6b5.js\",\"jJ356\",\"atlassian-light-increased-contrast.509a2e77.js\",\"122v8\",\"atlassian-dark.9e6236d3.js\",\"70xW7\",\"atlassian-dark-future.b9bb4959.js\",\"7CVFq\",\"atlassian-dark-increased-contrast.85e9412a.js\",\"krq8D\",\"atlassian-legacy-light.fc9c71c3.js\",\"cJx16\",\"atlassian-legacy-dark.904b9734.js\",\"bmBcz\",\"atlassian-spacing.ff832cd9.js\",\"13TCz\",\"atlassian-typography.c8d8f97d.js\",\"gIHSI\",\"atlassian-shape.0c575123.js\",\"4L9Dv\",\"custom-theme.6e0c9c02.js\",\"jPVOA\",\"atlassian-light.fdd18737.js\",\"1NaxE\",\"atlassian-light-future.63657c89.js\",\"k4PkF\",\"atlassian-light-increased-contrast.694906bd.js\",\"ocJPN\",\"atlassian-dark.c03f6bb4.js\",\"aTqqL\",\"atlassian-dark-future.2c41867c.js\",\"f4J8q\",\"atlassian-dark-increased-contrast.9ec2cb9a.js\",\"8Um41\",\"atlassian-legacy-light.aba2c828.js\",\"8XTaB\",\"atlassian-legacy-dark.9ef93e34.js\",\"iPkcz\",\"atlassian-spacing.b3186e39.js\",\"jVTSt\",\"atlassian-typography.dcae6083.js\",\"d6yQp\",\"atlassian-shape.1b070d93.js\",\"5gLA6\",\"custom-theme.cd4a04c3.js\",\"dfPS6\",\"atlassian-light.1c0a116a.js\",\"6baOm\",\"atlassian-light-future.b4843f4c.js\",\"7yB3Q\",\"atlassian-light-increased-contrast.961e5a35.js\",\"iQnma\",\"atlassian-dark.95380b77.js\",\"9DJea\",\"atlassian-dark-future.963c8f65.js\",\"4oQOs\",\"atlassian-dark-increased-contrast.900b57b9.js\",\"iDduo\",\"atlassian-legacy-light.f9d5b85c.js\",\"31Wqw\",\"atlassian-legacy-dark.100214fe.js\",\"e2tYh\",\"atlassian-spacing.6eec4566.js\",\"luvRZ\",\"atlassian-typography.0136ca39.js\",\"m7ggT\",\"atlassian-shape.f4c9679b.js\",\"kNjuE\",\"custom-theme.d41d3058.js\",\"ltlXq\",\"body.a14d4ad4.js\",\"48QfK\",\"esm.8db146b8.js\",\"gPZkX\",\"sha256SimpleHasher.0d27bb2e.js\",\"fuffb\",\"sha256SimpleHasher.46788184.js\",\"fKM6M\",\"simpleHasher.1634ab46.js\",\"lS4iW\",\"mobile-upload.719f16c5.js\",\"6pCA8\",\"mobile-upload.cc3fa6bc.js\",\"aFNpo\",\"browser.be57f803.js\",\"faL9r\",\"atlassian-light.1eed569c.js\",\"bThcZ\",\"atlassian-light-future.1c10eaca.js\",\"jgp9Y\",\"atlassian-light-increased-contrast.80ebdd5a.js\",\"fuD86\",\"atlassian-dark.d920d9d6.js\",\"6tdv9\",\"atlassian-dark-future.8be13baf.js\",\"5sIHz\",\"atlassian-dark-increased-contrast.07e18458.js\",\"ikR9S\",\"atlassian-legacy-light.93b2f6ce.js\",\"5A7oE\",\"atlassian-legacy-dark.90f0bf9c.js\",\"kOg9x\",\"atlassian-spacing.7f49a6c3.js\",\"d1QZr\",\"atlassian-typography.67c4dbba.js\",\"8fB1m\",\"atlassian-shape.f944ab0b.js\",\"9xWHS\",\"custom-theme.6e27a20a.js\",\"LTfzx\",\"media.6374d850.js\",\"lgIW5\",\"js.7d56d25b.js\",\"brZAs\",\"png-chunks-extract.4cbad1b2.js\",\"kSEDB\",\"windowedCodeBlock.3d2d14dd.js\",\"4oYI8\",\"block.84e068de.js\",\"cRpp3\",\"block.89db792a.js\",\"5NFw4\",\"refractor.221bfc03.js\",\"5eEvQ\",\"windowedCodeBlock.28a1b257.js\",\"7t7VP\",\"codeBlock.fa8b5389.js\",\"3PUK1\",\"taskList.22b49611.js\",\"acB4n\",\"taskItem.af23bd34.js\",\"kWJYy\",\"taskItem.ffc2d018.js\",\"cQBGj\",\"decisionList.d527dda6.js\",\"9FoVh\",\"decisionItem.2d54d7c3.js\",\"3biLQ\",\"date.120c6732.js\",\"h95CX\",\"status.2e05cb45.js\",\"aTkCf\",\"status.fb842c6a.js\",\"cYMOh\",\"emoji.f8abb3e8.js\",\"cEjHe\",\"emoji.d276f9ac.js\",\"8krYg\",\"custom-theme.82ab1cf2.js\",\"7Lbuq\",\"atlassian-light.ba74eda4.js\",\"70Xzf\",\"atlassian-light-future.d7e4e814.js\",\"7vLwj\",\"atlassian-light-increased-contrast.ec23e7ea.js\",\"gdxOf\",\"atlassian-dark.4b1d21ab.js\",\"e6GIv\",\"atlassian-dark-future.8aecc40c.js\",\"dcNlt\",\"atlassian-dark-increased-contrast.df024ab2.js\",\"lEZ5c\",\"atlassian-legacy-light.76bdca50.js\",\"8sT7M\",\"atlassian-legacy-dark.5a2c33fa.js\",\"25MQd\",\"atlassian-spacing.badebd5f.js\",\"7N1j7\",\"atlassian-typography.e349f33f.js\",\"5Nebg\",\"atlassian-shape.c9174143.js\",\"lAV1e\",\"panel.c70ded7f.js\",\"1B7Gg\",\"embedCard.f757434d.js\",\"53c1I\",\"blockCard.37ebf799.js\",\"3ybiy\",\"datasourceTableView.3332c721.js\",\"fuHSb\",\"inlineCard.1ff7f63e.js\",\"ljeUX\",\"inlineCard.208f6066.js\",\"lSyuz\",\"component-lazy.3af70125.js\",\"h0m3X\",\"audio-icon.ce444458.js\",\"5MTnN\",\"angle-brackets-icon.734a41f1.js\",\"joYbk\",\"folder-icon.a92cb1f5.js\",\"lalkF\",\"image-icon.5af814b8.js\",\"6oF2d\",\"video-icon.d16a1716.js\",\"5gOEa\",\"lock-locked--lock-filled.afc45503.js\",\"3o0pf\",\"24.a7d574ae.js\",\"5BU3O\",\"24.ab2189f8.js\",\"3Vtk4\",\"24.2320e571.js\",\"3YZy9\",\"24.16e7ec84.js\",\"7WbIj\",\"24.f3d78455.js\",\"eUDKG\",\"24.7dfbdf19.js\",\"2P2t2\",\"24.7ce0238b.js\",\"dbVND\",\"24.1bf1076d.js\",\"5cevN\",\"24.acd924c5.js\",\"idwKF\",\"24.ee28e8aa.js\",\"jBDBf\",\"24.11eefa71.js\",\"garab\",\"24.ea74a6b2.js\",\"kA15Q\",\"24.ab11d1d3.js\",\"aZqy1\",\"confluence-icon.b6395dae.js\",\"9SHWr\",\"jira-icon.81ec4907.js\",\"36ooX\",\"attachment.b85ff5be.js\",\"ehVjG\",\"task.9787f5af.js\",\"iNg9c\",\"component.a626ee25.js\",\"ToOlT\",\"comment.00e7d974.js\",\"5DPYi\",\"eye-open--watch.37e60770.js\",\"aJpEe\",\"thumbs-up--like.d12b211c.js\",\"8yHD5\",\"arrow-up.05fa84c9.js\",\"fPbsM\",\"question-circle--question.85378911.js\",\"4ivcO\",\"angle-brackets--code.08d9ff80.js\",\"1pkve\",\"people-group--people.f92098d0.js\",\"l6fcu\",\"subtasks--subtask.70814827.js\",\"bbdre\",\"goal-icon.1950d88d.js\",\"j4IS4\",\"projects-icon.15ec5be3.js\",\"bWl0R\",\"manual-triggers-modal.b5610c0d.js\",\"iQ1BA\",\"RelatedLinksModal.42a7a1c1.js\",\"053cf\",\"EmbedModal.c36fff10.js\",\"lcZFf\",\"custom-theme.994e6640.js\",\"eZm2h\",\"atlassian-light.512fc1f8.js\",\"jYZcQ\",\"atlassian-light-future.d02577ef.js\",\"5zK6v\",\"atlassian-light-increased-contrast.e00b036f.js\",\"kAYrf\",\"atlassian-dark.19ba59a2.js\",\"ftXjB\",\"atlassian-dark-future.396954b2.js\",\"dG5Lk\",\"atlassian-dark-increased-contrast.c8703a70.js\",\"6WgiH\",\"atlassian-legacy-light.b7cce9a1.js\",\"50slF\",\"atlassian-legacy-dark.1cc97140.js\",\"4YHPB\",\"atlassian-spacing.4a32bef9.js\",\"gTefI\",\"atlassian-typography.4c0f6f81.js\",\"1EZt6\",\"atlassian-typography-adg3.eca0bcab.js\",\"c5XTC\",\"atlassian-shape.d3ee31c4.js\",\"jLjAZ\",\"atlassian-shape-rounder.61cf16d9.js\",\"8Utct\",\"atlassian-shape-roundest.521525ae.js\",\"f9Kcs\",\"atlassian-typography-modernized.52aa6c57.js\",\"bQJhR\",\"atlassian-typography-refreshed.91d42c35.js\",\"6p1nh\",\"atlassian-light-brand-refresh.75441359.js\",\"9yzVz\",\"atlassian-dark-brand-refresh.dfa68039.js\",\"jgcY4\",\"datasourceRenderFailedAnalyticsWrapper.0b254d51.js\",\"6ZkQJ\",\"media.9ba7b138.js\",\"i4tio\",\"media.b6bc4196.js\",\"8UV89\",\"mobile-upload.34324754.js\",\"d5mCu\",\"sha256SimpleHasher.3f333c91.js\",\"dNthE\",\"simpleHasher.d67fb231.js\",\"2TJ5h\",\"simpleHasher.41ae9cdf.js\",\"co6p9\",\"media-viewer-error-boundary.89ff3efe.js\",\"fLhBf\",\"archive.8322eac9.js\",\"erJfA\",\"archive.7fafc2d0.js\",\"94YMa\",\"archive.60e899da.js\",\"j0ork\",\"codeViewerRenderer.0fba1c06.js\",\"8vFBh\",\"image.39c90256.js\",\"aYNQf\",\"video.1ffdb4b1.js\",\"aUHoI\",\"video.a82833bd.js\",\"zHa9m\",\"mobile-upload.79ba45e4.js\",\"7np7S\",\"sha256SimpleHasher.ce937495.js\",\"fbUxk\",\"simpleHasher.8c128c19.js\",\"6gI1z\",\"audio.837a7ea4.js\",\"fMChD\",\"doc.205ea28a.js\",\"gY7tF\",\"doc.2e40dde2.js\",\"7SzkJ\",\"codeViewer.c32a17dd.js\",\"6VMUa\",\"codeViewer.98908d07.js\",\"bttaS\",\"dist.50b86e5e.js\",\"1OvQm\",\"dist.8f2d17ef.js\",\"6Kt0L\",\"dist.e944937c.js\",\"01GtD\",\"dist.b36a57de.js\",\"1KljQ\",\"dist.f2f91e54.js\",\"23D1K\",\"dist.a1df9e36.js\",\"5sBDe\",\"dist.d13708ed.js\",\"cfsIz\",\"dist.0c86529b.js\",\"goUFM\",\"dist.03e1fc0d.js\",\"bhDxP\",\"dist.f27041d3.js\",\"i6Fxq\",\"dist.d038a04b.js\",\"7euOy\",\"dist.cffed5af.js\",\"fIdB5\",\"dist.fcfe3781.js\",\"poOsA\",\"dist.214e896e.js\",\"fJOYa\",\"dist.626a8a95.js\",\"inNnj\",\"dist.7f3f22dd.js\",\"f8nMc\",\"dist.a82e456f.js\",\"8aWee\",\"dist.a33db19d.js\",\"ekyBH\",\"dist.8a945a40.js\",\"10xwl\",\"dist.b5e46cd1.js\",\"4p2if\",\"apl.a0da11e8.js\",\"dBhHg\",\"asciiarmor.57cfbe0f.js\",\"2wZ9C\",\"asn1.68751da0.js\",\"da8IW\",\"asterisk.66eb8f9c.js\",\"8oHtT\",\"brainfuck.beec29d9.js\",\"lFgtK\",\"cobol.f9f604f4.js\",\"cD5nw\",\"clike.538150b1.js\",\"iDLPx\",\"clojure.5362ef50.js\",\"44L7z\",\"css.83536687.js\",\"h3KkC\",\"cmake.dc5f7601.js\",\"51cli\",\"coffeescript.f3ef0819.js\",\"8StR8\",\"commonlisp.8b9b0ebb.js\",\"6k3av\",\"cypher.535beb3e.js\",\"imTMZ\",\"python.b6446198.js\",\"8LylS\",\"crystal.90a5c8fd.js\",\"24N01\",\"d.996504f1.js\",\"hYP4d\",\"diff.cdd4209c.js\",\"qM2T1\",\"dockerfile.e1a003b1.js\",\"bLKFw\",\"dtd.096942b3.js\",\"dbq97\",\"dylan.f0db0aae.js\",\"fGgZv\",\"ebnf.00c1832f.js\",\"85Tc7\",\"ecl.9e11e3b8.js\",\"19diC\",\"eiffel.efe8ff62.js\",\"aE8L0\",\"elm.edd840a2.js\",\"1OUqX\",\"erlang.e2434029.js\",\"iwfY1\",\"sql.c3fa8f75.js\",\"UoFo6\",\"factor.26070e29.js\",\"6Kdlc\",\"fcl.2d90fde3.js\",\"iKykS\",\"forth.6ed42b28.js\",\"gqg57\",\"fortran.bd397374.js\",\"iWmK9\",\"mllike.ac6a6d29.js\",\"dDto5\",\"gas.3f0efc72.js\",\"3B9QV\",\"gherkin.e770e3dd.js\",\"9GLE4\",\"groovy.3720ca95.js\",\"dJQax\",\"haskell.b524edce.js\",\"e7hU8\",\"haxe.2159e389.js\",\"9q3vN\",\"http.e2cd5a26.js\",\"fOtJf\",\"idl.be8c4089.js\",\"cVueU\",\"javascript.1b905e7a.js\",\"2n0nj\",\"jinja2.6f6060bf.js\",\"6gSx2\",\"julia.398b6412.js\",\"jN9l6\",\"livescript.19a27f23.js\",\"c8qRK\",\"lua.bd809cab.js\",\"3AND5\",\"mirc.0aacf508.js\",\"b2cLX\",\"mathematica.ec5b0959.js\",\"ZMHeR\",\"modelica.e3c76697.js\",\"21nuu\",\"mumps.f19d4fbe.js\",\"3thkD\",\"mbox.6d7be4d0.js\",\"hjATh\",\"nginx.d081012a.js\",\"hP1RP\",\"nsis.670ee136.js\",\"e3Tvg\",\"ntriples.25ca993f.js\",\"cuS8X\",\"octave.e376ae68.js\",\"hsUFD\",\"oz.57fdfa2d.js\",\"isxJL\",\"pascal.9ab0ef59.js\",\"9ewuc\",\"perl.2733bf68.js\",\"5Jsj3\",\"pig.336cf4ae.js\",\"1sko9\",\"powershell.3e712324.js\",\"lVfki\",\"properties.b6765720.js\",\"jDcjw\",\"protobuf.845b2e3f.js\",\"731OY\",\"pug.a4ebeb2a.js\",\"d8uo8\",\"puppet.6d8ac284.js\",\"3l4vo\",\"q.1e8324d0.js\",\"kAUdd\",\"r.c1b263e8.js\",\"86Yhc\",\"rpm.43838c86.js\",\"9O5VG\",\"ruby.108bd4be.js\",\"4g5gT\",\"sas.434ae237.js\",\"i8z7Z\",\"scheme.4da8c09e.js\",\"aY3nK\",\"shell.1c5e82aa.js\",\"02obJ\",\"sieve.1746b552.js\",\"kjCZL\",\"smalltalk.10052dac.js\",\"egMAQ\",\"solr.2c5a8f34.js\",\"4iT61\",\"sparql.43ec517c.js\",\"dHap4\",\"spreadsheet.68a3ce6e.js\",\"kUJcJ\",\"stylus.43b7c093.js\",\"do6Wl\",\"swift.6105598b.js\",\"2APaA\",\"stex.df3649f9.js\",\"3e71W\",\"verilog.c36b77e7.js\",\"kUsBB\",\"tcl.014c9855.js\",\"4tgAb\",\"textile.0cbe930c.js\",\"jg4Z2\",\"tiddlywiki.4802482b.js\",\"6x548\",\"tiki.6e708b31.js\",\"c4c6S\",\"toml.b43e79fe.js\",\"gXiWJ\",\"troff.ec118a63.js\",\"bz8sX\",\"ttcn.84aaa090.js\",\"4Q9cH\",\"ttcn-cfg.c932ff2c.js\",\"dCV7Q\",\"turtle.896c5d9d.js\",\"e6cuf\",\"webidl.b95fc672.js\",\"6TqOb\",\"vb.1ceabe1e.js\",\"eiHCt\",\"vbscript.1f14fb9a.js\",\"8Yvby\",\"velocity.8fc18450.js\",\"1fTqC\",\"vhdl.c1d25818.js\",\"1Y4ow\",\"xquery.95a8d6b8.js\",\"6rGto\",\"yacas.d2ef49a3.js\",\"bceUd\",\"z80.e5d0b66e.js\",\"jxhBg\",\"mscgen.9f1115b9.js\",\"2Vlxp\",\"dist.00fc6072.js\",\"hTW6s\",\"dist.9da4beb3.js\",\"jWrLf\",\"svg.de70ea6c.js\",\"lPkac\",\"svg.11416c3c.js\",\"cpe2g\",\"media-viewer-error-boundary.0333085a.js\",\"944qR\",\"media-viewer-error-boundary.1cf9c261.js\",\"jcR9G\",\"custom-theme.2bf8e3b8.js\",\"lr62D\",\"atlassian-light.ac34536e.js\",\"f0syU\",\"atlassian-light-future.f70f09f9.js\",\"lNabo\",\"atlassian-light-increased-contrast.44902867.js\",\"5fGYU\",\"atlassian-dark.cbbe7a71.js\",\"fzJEZ\",\"atlassian-dark-future.c17292d5.js\",\"kexuZ\",\"atlassian-dark-increased-contrast.76ec909e.js\",\"fvI5P\",\"atlassian-legacy-light.ae5c0ace.js\",\"4IEOH\",\"atlassian-legacy-dark.56f17fa5.js\",\"f5Ybm\",\"atlassian-spacing.9bd51db4.js\",\"JggFT\",\"atlassian-typography.a9ea81af.js\",\"234Zi\",\"atlassian-shape.1af6c2fe.js\",\"asYBQ\",\"mobile-upload.0acd13b4.js\",\"iOYmR\",\"sha256SimpleHasher.ba7d2efa.js\",\"kGqXF\",\"simpleHasher.abbc29ed.js\",\"2QqfK\",\"inlinePlayer.360d4eca.js\",\"kllXB\",\"media.1fa920d7.js\",\"afp8c\",\"mediaGroup.36bf48f9.js\",\"dORXn\",\"mediaGroup.1dbd8c15.js\",\"fKug8\",\"mediaInline.eac80891.js\",\"hsKcV\",\"mediaInline.2d3e6236.js\",\"hJYnA\",\"media-viewer-error-boundary.8be5a8a4.js\",\"7ehwg\",\"sha256SimpleHasher.f1df0569.js\",\"6QvEc\",\"simpleHasher.c1c07c09.js\",\"hhyL3\",\"mobile-upload.5fc95ad2.js\",\"6utrM\",\"archive.33becc79.js\",\"bGUAd\",\"codeViewerRenderer.74969577.js\",\"hLPOa\",\"image.37f344f1.js\",\"bzau0\",\"video.3b37b473.js\",\"ebte3\",\"audio.515d3033.js\",\"043rC\",\"doc.3d456ef4.js\",\"auLb3\",\"codeViewer.126cd4c9.js\",\"8oZD1\",\"svg.ab7337ea.js\",\"eI2ae\",\"custom-theme.3f41b635.js\",\"bK09S\",\"atlassian-light.323a2667.js\",\"9ZjCW\",\"atlassian-light-future.62188a13.js\",\"2i01G\",\"atlassian-light-increased-contrast.00ec382c.js\",\"ikk5X\",\"atlassian-dark.4060a525.js\",\"isMgS\",\"atlassian-dark-future.5524e72f.js\",\"42PvW\",\"atlassian-dark-increased-contrast.2b8ed4fe.js\",\"9mlRK\",\"atlassian-legacy-light.79d84f5a.js\",\"gAgap\",\"atlassian-legacy-dark.21e5d74d.js\",\"9o9zt\",\"atlassian-spacing.1b9ba721.js\",\"bPl9H\",\"atlassian-typography.ff7e49bf.js\",\"6p98p\",\"atlassian-shape.1132b0a6.js\",\"18GuL\",\"esm.3fbe7052.js\",\"QIw1s\",\"mediaInlineCard.6d46d439.js\",\"kmnJr\",\"sha256SimpleHasher.7552b97b.js\",\"2c8UN\",\"simpleHasher.70b1b588.js\",\"e5DOm\",\"mediaInlineAnalyticsErrorBoundary.99465ba2.js\",\"cziOs\",\"mediaSingle.1ac52bba.js\",\"crSct\",\"mention.3fb27b7b.js\",\"ge1If\",\"mention.1e527de1.js\",\"1HxWa\",\"cs.38b90fde.js\",\"31AZy\",\"da.17065e85.js\",\"iHaOG\",\"de.8d374abd.js\",\"lAeY6\",\"en.4e61a02f.js\",\"kndgx\",\"en_GB.e64f58c4.js\",\"bcVAn\",\"en_ZZ.d7948f0c.js\",\"gJwZN\",\"es.33bcdec5.js\",\"38gbK\",\"et.9231c2f5.js\",\"kvcKj\",\"fi.21a70df8.js\",\"7m2z1\",\"fr.7c739022.js\",\"lXSKI\",\"hu.682f6da1.js\",\"bOwv9\",\"is.0f93845a.js\",\"bQuYd\",\"it.195e2fdc.js\",\"3wiTB\",\"ja.448f1de2.js\",\"ax3N6\",\"ko.52ce8702.js\",\"8Oko1\",\"nb.78f1ed1c.js\",\"23DF8\",\"nl.54c4efad.js\",\"cT9Lk\",\"pl.674672b1.js\",\"1ErJf\",\"pt_BR.e0d87ef3.js\",\"d9Ufj\",\"pt_PT.c8ead12f.js\",\"kNjdB\",\"ro.c4018960.js\",\"leNQu\",\"ru.b7faeb11.js\",\"jyQ1P\",\"sk.b9afadde.js\",\"kRYc4\",\"sv.58481223.js\",\"l8Gaq\",\"th.aceef559.js\",\"2PFqk\",\"tr.9a2c4b26.js\",\"asdIR\",\"uk.7ecd68f8.js\",\"6Wvi1\",\"vi.bf1111d0.js\",\"igYVg\",\"zh_TW.5c5621ef.js\",\"2hiIW\",\"zh.c45e3ae2.js\",\"fQr2e\",\"main.caf6f61b.js\",\"d9kMY\",\"atlassian-light.0a05cc27.js\",\"ijBxB\",\"atlassian-light-future.155181f0.js\",\"chFSP\",\"atlassian-light-increased-contrast.b098ccab.js\",\"lEqKc\",\"atlassian-dark.33cc077c.js\",\"eeVVU\",\"atlassian-dark-future.760f475c.js\",\"kTJ6e\",\"atlassian-dark-increased-contrast.2ddf000e.js\",\"lwEG8\",\"atlassian-legacy-light.85206ba1.js\",\"jaBaa\",\"atlassian-legacy-dark.39d03b62.js\",\"3YNRX\",\"atlassian-spacing.805abe89.js\",\"dIwCG\",\"atlassian-typography.53a136f4.js\",\"k9F8p\",\"atlassian-shape.16c53b28.js\",\"HEdLE\",\"custom-theme.a5ef1dc4.js\",\"5jLNe\",\"main.5fd5a865.js\",\"51Wri\",\"atlassian-light.8a676cc3.js\",\"efC7W\",\"atlassian-light-future.071b2c0c.js\",\"fK5l6\",\"atlassian-light-increased-contrast.00762e5c.js\",\"6wYXz\",\"atlassian-dark.4430a258.js\",\"3vKFU\",\"atlassian-dark-future.1abc6319.js\",\"lm4NP\",\"atlassian-dark-increased-contrast.81b5385d.js\",\"gUaBF\",\"atlassian-legacy-light.95a834ef.js\",\"fp1Ti\",\"atlassian-legacy-dark.cd215829.js\",\"hHBgS\",\"atlassian-spacing.09982fe0.js\",\"4lJrm\",\"atlassian-typography.23f3889c.js\",\"gkuHl\",\"atlassian-shape.07d11a8c.js\",\"gXiCn\",\"custom-theme.1a27b7b9.js\",\"c8Yth\",\"custom-theme.a3addd1c.js\",\"kngF7\",\"atlassian-light.22622860.js\",\"1oPIl\",\"atlassian-light-future.a52671f0.js\",\"jjz9J\",\"atlassian-light-increased-contrast.278f4abe.js\",\"a0z9R\",\"atlassian-dark.c44ef2f8.js\",\"63wJ3\",\"atlassian-dark-future.5751bacc.js\",\"f0euw\",\"atlassian-dark-increased-contrast.2b83fac2.js\",\"d93Rm\",\"atlassian-legacy-light.4c743248.js\",\"gjy50\",\"atlassian-legacy-dark.d3666dc6.js\",\"2CS1Q\",\"atlassian-spacing.3b997412.js\",\"bhs6t\",\"atlassian-typography.63401760.js\",\"6c8Jr\",\"atlassian-shape.03b6eee4.js\",\"6OiyO\",\"custom-theme.cd582253.js\",\"37Xwv\",\"atlassian-light.e8d6a325.js\",\"3M0aX\",\"atlassian-light-future.57b71948.js\",\"5q947\",\"atlassian-light-increased-contrast.18169dd1.js\",\"6gSVu\",\"atlassian-dark.afea4199.js\",\"c7UVU\",\"atlassian-dark-future.5d77fb69.js\",\"hb9eP\",\"atlassian-dark-increased-contrast.75805e17.js\",\"8U6fj\",\"atlassian-legacy-light.615cc43d.js\",\"9EKJ6\",\"atlassian-legacy-dark.f66656c7.js\",\"jJLxQ\",\"atlassian-spacing.52a82368.js\",\"gJfTO\",\"atlassian-typography.fd44aa05.js\",\"ehMTv\",\"atlassian-shape.5c7ff0c7.js\",\"fCdeh\",\"AgentProfileCard.d48461f7.js\",\"iAd6M\",\"auto-dev.ffa3236c.js\",\"hZ56t\",\"auto-fix.acb945c3.js\",\"9Q9B7\",\"auto-review.ebfeee1c.js\",\"kyZNm\",\"backlog-buddy.b840ca43.js\",\"cW2Sl\",\"comms-crafter.cb2fed6d.js\",\"dPmlZ\",\"culture.8570325c.js\",\"ff2ox\",\"customer-insight.480026ee.js\",\"lyT49\",\"decision-director.26dcd38d.js\",\"g8ELo\",\"feature-flag-avatar.065cb266.js\",\"2KQUN\",\"generic-avatar.d8cfcdeb.js\",\"5fVAX\",\"hire-writer.1b6010ba.js\",\"Ol8P7\",\"marketing-message-maestro.6cfb2916.js\",\"b5bBG\",\"my-user-manual.ec611aaa.js\",\"gkbjq\",\"okr-oracle.3ac1f38f.js\",\"7aitr\",\"ops-agent.59a1bfb6.js\",\"4I8sx\",\"pitch-perfector.12bc2c75.js\",\"ivXfZ\",\"product-requirement.7dae5229.js\",\"C2UU7\",\"release-notes.48c66e11.js\",\"ARR1a\",\"research-scout.968ad140.js\",\"jrUTw\",\"rovo-dev.59169f3c.js\",\"7ByjE\",\"social-media-scribe.1e9aa38e.js\",\"bGLjm\",\"team-connection.492a4449.js\",\"7MGbX\",\"workflow-builder.a8b905e2.js\",\"fqNh3\",\"trial-guide.10e9e565.js\",\"hL5ii\",\"jsm-rovo-service-agent.9516ac96.js\",\"bsCTQ\",\"amplitude-agent.74f7ca08.js\",\"50DPv\",\"box-agent.b09d35e1.js\",\"2Cle5\",\"canva-agent.0ea285f9.js\",\"66Spl\",\"figma-agent.7cc0cf9d.js\",\"88X5j\",\"hubspot-agent.956f99d3.js\",\"8Sl5W\",\"intercom-agent.e6f085f6.js\",\"f7x10\",\"gamma-agent.dd8e7332.js\",\"cHszp\",\"AgentProfileCard.9cdf3162.js\",\"i9RPe\",\"ProfileCard.0e164951.js\",\"8sead\",\"Expand.9571469d.js\",\"gj6MI\",\"syncBlock.9e2dd6e3.js\",\"3lLZB\",\"bodiedSyncBlock.d458bfb7.js\",\"7Q4ht\",\"view.4e28631d.js\",\"gFcxC\",\"view.8e10e432.js\",\"9WEDO\",\"view.d38315f2.js\",\"49mlB\",\"esm.7e712803.js\",\"irTWb\",\"chat-widget-omni-channel-ui.a253bf84.js\",\"7dU12\",\"esm.74b69e1b.js\",\"cXOXe\",\"custom-theme.3d6bb433.js\",\"6gTh3\",\"atlassian-light.583093f5.js\",\"dDmTi\",\"atlassian-light-future.2c6ed7dc.js\",\"16zvp\",\"atlassian-light-increased-contrast.45e89690.js\",\"3dz69\",\"atlassian-dark.b5594333.js\",\"k8DtJ\",\"atlassian-dark-future.1c059d0b.js\",\"jtSSZ\",\"atlassian-dark-increased-contrast.20d3cd05.js\",\"eoqiN\",\"atlassian-legacy-light.80fc2647.js\",\"czZoh\",\"atlassian-legacy-dark.ac0eeb1a.js\",\"jExvY\",\"atlassian-spacing.34f75cc0.js\",\"9njwY\",\"atlassian-typography.b555aa30.js\",\"ePzeI\",\"atlassian-shape.fe47619e.js\",\"8qSAx\",\"esm.1f5327c2.js\",\"ius3F\",\"mobile-upload.f38e729d.js\",\"it8iU\",\"sha256SimpleHasher.6263ef89.js\",\"l9mlb\",\"simpleHasher.d8e280e5.js\",\"hCwjc\",\"esm.5726b520.js\",\"eDmkW\",\"mention.954c9c37.js\",\"1UZeW\",\"chat-widget-omni-channel-ui.2cc302d3.js\",\"hx68B\",\"chat-widget-customer-analytics.c7efcc0b.js\"]"));


//# sourceMappingURL=jira-product-discovery-page.8ecb75cb.js.map
